import * as constants from "./constants";

export const setLocationDetailsIsEdit = (data) => {
  return {
    type: constants.LOCATION_DETAILS_IS_EDIT,
    data: data,
  };
};

export const createLocation = (data) => {
  return {
    type: constants.CREATE_LOCATION,
    data: data,
  };
};

export const createLocationSuccess = (data) => {
  return {
    type: constants.CREATE_LOCATION_SUCCESS,
    data: data,
  };
};

export const createLocationError = () => {
  return {
    type: constants.CREATE_LOCATION_ERROR,
  };
};

export const fetchLocation = (data) => {
  return {
    type: constants.FETCH_LOCATION,
    data: data,
  };
};

export const fetchLocationSuccess = (data) => {
  return {
    type: constants.FETCH_LOCATION_SUCCESS,
    data,
  };
};

export const fetchLocationError = () => {
  return {
    type: constants.FETCH_LOCATION_ERROR,
  };
};

export const updateLocation = (data) => {
  return {
    type: constants.UPDATE_LOCATION,
    data: data,
  };
};

export const updateLocationSuccess = (data) => {
  return {
    type: constants.UPDATE_LOCATION_SUCCESS,
    data: data,
  };
};

export const updateLocationError = () => {
  return {
    type: constants.UPDATE_LOCATION_ERROR,
  };
};

export const fetchLocations = () => {
  return {
    type: constants.FETCH_LOCATION,
  };
};

export const fetchAllLocations = (data) => {
  return {
    type: constants.FETCH_ALL_LOCATIONS,
    data,
  };
};

export const fetchAllLocationsSuccess = (data) => {
  return {
    type: constants.FETCH_ALL_LOCATIONS_SUCCESS,
    data,
  };
};

export const fetchAllLocationsError = (error) => {
  return {
    type: constants.FETCH_ALL_LOCATIONS_ERROR,
    error,
  };
};

export const deleteLocation = (data) => {
  return {
    type: constants.DELETE_LOCATION,
    data,
  };
};

export const deleteLocationSuccess = (data) => {
  return {
    type: constants.DELETE_LOCATION_SUCCESS,
    data,
  };
};

export const deleteLocationError = (data) => {
  return {
    type: constants.DELETE_LOCATION_ERROR,
    data,
  };
};

export const deleteLocationAttach = (data) => {
  return {
    type: constants.DELETE_LOCATION_ATTACH,
    data,
  };
};

export const deleteLocationAttachSuccess = (data) => {
  return {
    type: constants.DELETE_LOCATION_ATTACH_SUCCESS,
    data,
  };
};

export const deleteLocationAttachError = (data) => {
  return {
    type: constants.DELETE_LOCATION_ATTACH_ERROR,
    data,
  };
};

export const setLocationNotificationIsEdit = (data) => {
  return {
    type: constants.LOCATION_NOTIF_IS_EDIT,
    data,
  };
};

export const locationDetailCleanupFunc = () => {
  return {
    type: constants.LOCATION_DETAIL_CLEANUP_FUNC,
  };
};

export const updateLocationNotifications = (data) => {
  return {
    type: constants.UPDATE_LOCATION_NOTIFICATION,
    data,
  };
};

export const updateLocationNotificationsSuccess = (data) => {
  return {
    type: constants.UPDATE_LOCATION_NOTIFICATION_SUCCESS,
    data,
  };
};

export const updateLocationNotificationsError = (data) => {
  return {
    type: constants.UPDATE_LOCATION_NOTIFICATION_ERROR,
    data,
  };
};
